import {AppThunk} from '../../index';
import {RegisterPollAnswerRequestPayload} from '../../../../shared/models/api';
import {GetPollResponsePayload} from '../../../../shared/models/api';
import {httpService, HttpWrapperOptions} from '../../../../shared/httpWrapper';
import {getApiRoute} from '../../../../shared/pipes/getApiRoute';
import {apiUrls} from '../../../../shared/constants/urls';
import {pollDetailsSlice} from '../../../reducers/polls/details';

export const setPollDetails = pollDetailsSlice.actions.setPoll;

export const getPollDetails = (pollId: number): AppThunk => {
  return async (dispatch) => {
    const response = await httpService.get<GetPollResponsePayload>(getApiRoute(apiUrls.getPoll, {pollId}));
    dispatch(setPollDetails(response));
  };
};

export const completePoll = async (payload: RegisterPollAnswerRequestPayload): Promise<void> => {
  await httpService.post(getApiRoute(apiUrls.completePoll), payload, new HttpWrapperOptions().Wait(true));
};
